import React from 'react';
import MetricChange from 'components/MetricChange';
import CenterContent from 'components/CenterContent';
import CurrencyFormat from 'components/CurrencyFormat';
import { useWebsiteCurrency } from 'hooks/useWebsiteCurrency';
import { getFormatter, numberFormat } from 'shared/utils/formatter';
import { getMetricPrecision } from 'shared/utils/metricPrecision';
import { metricSupportsChange, metricSupportsShareOfTotal } from 'shared/utils/metricChange';

const MetricValue = ({
  metric,
  row,
  showChange = false,
  showShareOfTotal = false,
  total,
  maximumFractionDigits,
  precisionContext = 'display',
}) => {
  const { currency, ready } = useWebsiteCurrency();
  let value = row?.[metric.name];
  let type = metric.type || 'number';

  if (value != null && showShareOfTotal && metricSupportsShareOfTotal(metric) && total) {
    type = 'percent';
    value /= total;
  }

  const fractionDigits = maximumFractionDigits ?? getMetricPrecision(metric, precisionContext);

  let formattedValue;
  if (type === 'currency') {
    if (!ready) {
      formattedValue = '';
    } else if (currency) {
      formattedValue = (
        <CurrencyFormat
          value={value}
          currency={currency}
          maximumFractionDigits={fractionDigits ?? 2}
        />
      );
    } else {
      formattedValue = numberFormat(value, { maximumFractionDigits: fractionDigits ?? 2 });
    }
  } else {
    formattedValue = getFormatter(type, { maximumFractionDigits: fractionDigits, currency: ready ? currency : null })(value);
  }

  return (
    <CenterContent inline horizontal className="monospace">
      {formattedValue}
      {showChange && metricSupportsChange(metric) && <MetricChange metric={metric} row={row} />}
    </CenterContent>
  );
};

export default MetricValue;
